import { render, staticRenderFns } from "./form-import.html?vue&type=template&id=56388f43&"
import script from "./FormImport.vue?vue&type=script&lang=js&"
export * from "./FormImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports